"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _assign = _interopRequireDefault(require("lodash/fp/assign"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _DropdownContext = require("../Dropdown/DropdownContext");
var _ReservedOptions = require("../Dropdown/ReservedOptions");
var _utils = require("../Form/utils");
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
var _excluded = ["addon", "children", "className", "hasError", "hasWarning", "onChange", "placeholder", "size", "style", "value"];
/* eslint jsx-a11y/no-onchange: off */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NativeDropdown = function NativeDropdown(_ref, ref) {
  var addon = _ref.addon,
    children = _ref.children,
    className = _ref.className,
    hasError = _ref.hasError,
    hasWarning = _ref.hasWarning,
    onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'react-ui.common.dropdown.option.empty' : _ref$placeholder,
    size = _ref.size,
    style = _ref.style,
    value = _ref.value,
    htmlAttr = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var required = (0, _prop["default"])('aria-required')(htmlAttr);
  var ctx = (0, _react.useMemo)(function () {
    return {
      withinNativeDropdown: true
    };
  }, []);
  var handleChange = (0, _react.useCallback)(function (e) {
    onChange === null || onChange === void 0 || onChange(e.target.value);
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('native-dropdown', (0, _defineProperty2["default"])({}, "native-dropdown-".concat(size), !!size && size !== 'md'), className),
    style: style
  }, addon, /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({
    className: (0, _classnames["default"])('dropdown', (0, _defineProperty2["default"])({
      'has-error': hasError,
      'has-warning': hasWarning
    }, "dropdown-".concat(size), !!size && size !== 'md')),
    "data-testid": "native-dropdown",
    onChange: handleChange,
    ref: ref,
    value: value || _ReservedOptions.ReservedOptions.PLACEHOLDER
  }, (0, _compose["default"])((0, _assign["default"])({
    required: required
  }), (0, _omit["default"])('aria-required'), _utils.omitFormProps)(htmlAttr)), /*#__PURE__*/_react["default"].createElement(_DropdownContext.Provider, {
    value: ctx
  }, placeholder && /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], null, placeholder), children)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown-icon",
    "aria-hidden": "true"
  }));
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(NativeDropdown);
var _default = exports["default"] = Composed;